angular.module('shared').directive('contactLink', ["$filter", "ContactBadgeService", function($filter, ContactBadgeService) {
  return {
    restrict: 'E',
    scope: {
      id: '=',
      type: '=',
      name: '=',
      firstName: '=',
      lastName: '=',
      status: '=',
      archived: '=',
      hideBadge: '=',
      linkClass: '=',
      onClick: '&',
      target: '@',
      tabName: '@'
    },
    template: require('templates/shared/contact_link.html'),
    link: function($scope) {
      $scope.contactName = function() {
        if ($scope.name) {
          return $scope.name;
        } else {
          return `${$scope.firstName || ''} ${$scope.lastName || ''}`;
        }
      };
      $scope.contactBadgeClass = function() {
        return ContactBadgeService.get($scope.type, $scope.status);
      };
      return $scope.contactType = function() {
        return $filter('underscored')($scope.type) + 's';
      };
    }
  };
}]);
